import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Scissors } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { money } from "@/lib/fmt";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SplitQuote = ({ q }) => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState([]);
  const items = q.items || [];
  const toggle = (i) => {
    const g = items[i].group;
    const idx = g ? items.map((it, n) => (it.group === g ? n : -1)).filter((n) => n >= 0) : [i];
    setSel((s) => (s.includes(i) ? s.filter((n) => !idx.includes(n)) : [...new Set([...s, ...idx])]));
  };
  const save = async () => {
    try {
      const { data } = await api.post(`/quotations/${q.id}/split`, { item_indexes: sel });
      toast.success(`Penawaran ${data.display_no} dibuat`); setOpen(false); nav(`/quotations/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <Button variant="outline" className="bg-white" disabled={q.archived || !q.is_latest || items.length < 2} onClick={() => { setSel([]); setOpen(true); }} data-testid="detail-split-btn"><Scissors className="h-4 w-4 mr-1" />Pisahkan</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" aria-describedby={undefined} data-testid="split-dialog">
          <DialogHeader><DialogTitle className="font-heading">Pisahkan item dari {q.display_no}</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">Item yang dicentang dipindah ke penawaran baru <b>{q.quote_no}-B/C…</b> dan langsung dihapus dari penawaran ini. Harga & modal tetap mengikuti kalkulasi asal.</p>
          <div className="max-h-[50vh] divide-y overflow-auto rounded-lg border">
            {items.map((it, i) => (
              <label key={i} className={`flex cursor-pointer items-center gap-3 px-3 py-2 text-sm ${sel.includes(i) ? "bg-blue-50" : ""}`} data-testid={`split-item-${i}`}>
                <input type="checkbox" checked={sel.includes(i)} onChange={() => toggle(i)} data-testid={`split-check-${i}`} />
                <span className="flex-1">{it.name}{it.group && <span className="ml-2 rounded bg-slate-100 px-1.5 text-[10px]">Grup {it.group}</span>}</span>
                <span className="text-xs text-slate-500">{it.qty} × {money(it.sell_price, q.currency)}</span>
              </label>
            ))}
          </div>
          <Button disabled={!sel.length || sel.length >= items.length} onClick={save} data-testid="split-save-btn"><Scissors className="h-4 w-4 mr-1" />Pisahkan {sel.length} item</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
